module.exports = __webpack_public_path__ + "img/sld_mfm_inv_6_t1_b1_dark.abecac61.svg";